export enum VOUCHER_CARD_VARIANT {
  SUCCESS = 'success',
  ERROR = 'error',
  DISABLED = 'disabled',
}

export enum VoucherBadgeVariant {
  BottomFlat = 'BottomFlat',
  TopFlat = 'TopFlat',
  Default = 'Default',
}

export type IVoucherCardVariant = VOUCHER_CARD_VARIANT;
